import { Typography } from '@mui/material';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren<unknown> {
  className?: string;
  lightBg?: boolean;
}

export const NullState = (p: Props) => {
  return (
    <div className={classNames('rounded-lg text-muted text-center', p.className)}>{p.children}</div>
  );
};

export const NullMessage = (p: Props) => {
  return <p className="text-muted">{p.children}</p>;
};

export const NullMessageMui = (p: Props) => {
  return (
    <Typography variant="body1" color="text.secondary">
      {p.children}
    </Typography>
  );
};
